import script from "./BrandsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrandsList.vue?vue&type=script&lang=ts&setup=true"

import "./BrandsList.vue?vue&type=style&index=0&id=48416160&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48416160"]])

export default __exports__